import React, { memo } from "react";
import { Divider, Flex, Text } from "@chakra-ui/react";
import colors from "app/colors";

interface IProps {
  title: string;
  color: string;
}

const LeftNavSectionHeader = ({ title, color }: IProps) => (
  <Flex w="full" align="center">
    <Text color={color} fontWeight={500} fontSize={11} fontFamily="Outfit">
      {title}
    </Text>
    <Divider ml="10px" borderColor={colors.gray50} />
  </Flex>
);

export default memo(LeftNavSectionHeader);
